import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  BestFareOptionsMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  OneWayRoutePickerMachCoreComponent,
  OptionsExpanderMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';
import { ModifyBookWidgetBaseComponent } from '../modify-book-widget-base/modify-book-widget-base.component';

@Component({
  selector: 'idp-modify-book-widget-mobile-ow-rt',
  standalone: true,
  imports: [
    CommonModule,
    OptionsExpanderMachCoreComponent,
    OneWayRoutePickerMachCoreComponent,
    SelectMachCoreComponent,
    DatePickerMachCoreComponent,
    BestFareOptionsMachCoreComponent,
    MeetingCodeMachCoreComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modify-book-widget-mobile-ow-rt.component.html'
})
export class ModifyBookWidgetOwRtMobileComponent extends ModifyBookWidgetBaseComponent {}
